export const COOKIE_CONSENT_LINKS = {
  PRIVACY_POLICY: 'https://commercetools.com/privacy#website',
  USER_GUIDING_COOKIE_POLICY: 'https://userguiding.com/cookie-policy/',
};
